import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const LoginScreen = () => {
  useEffect(() => {
    document.title = 'Days in the Life of Mz. Porter | Login';
  }, []);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { requestMagicLink } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const result = await requestMagicLink(email);

    setLoading(false);

    if (result.success) {
      setSubmitted(true);
    } else {
      setError(result.error);
    }
  };

  if (submitted) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.iconContainer}>
            <span style={styles.icon}>&#x2709;</span>
          </div>
          <h1 style={styles.title}>Check Your Email</h1>
          <p style={styles.message}>
            We've sent a login link to <strong>{email}</strong>
          </p>
          <p style={styles.subMessage}>
            Click the link in the email to sign in. The link will expire in 15 minutes.
          </p>
          <button
            onClick={() => {
              setSubmitted(false);
              setEmail('');
            }}
            style={styles.linkButton}
          >
            Use a different email
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Days in the Life of Mz. Porter</h1>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              style={styles.input}
              disabled={loading}
            />
          </div>

          {error && (
            <div style={styles.error}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !email}
            style={{
              ...styles.button,
              opacity: loading || !email ? 0.6 : 1
            }}
          >
            {loading ? 'Sending...' : 'Send me a login link'}
          </button>
        </form>

        <p style={styles.footer}>
          We'll email you a secure login link.
          <br />
          No password needed.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1a1a1a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  card: {
    backgroundColor: '#2a2a2a',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center'
  },
  iconContainer: {
    marginBottom: '20px'
  },
  icon: {
    fontSize: '64px'
  },
  title: {
    color: '#ffffff',
    fontSize: '32px',
    fontWeight: 'bold',
    margin: '0 0 30px 0'
  },
  subtitle: {
    color: '#888',
    fontSize: '16px',
    margin: '0 0 30px 0'
  },
  message: {
    color: '#ffffff',
    fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '15px'
  },
  subMessage: {
    color: '#888',
    fontSize: '14px',
    lineHeight: '1.6',
    marginBottom: '30px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  inputGroup: {
    textAlign: 'left'
  },
  label: {
    color: '#888',
    fontSize: '14px',
    display: 'block',
    marginBottom: '8px'
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    fontSize: '16px',
    backgroundColor: '#1a1a1a',
    border: '1px solid #3a3a3a',
    borderRadius: '8px',
    color: '#ffffff',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s'
  },
  button: {
    backgroundColor: '#4CAF50',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '14px 32px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  linkButton: {
    backgroundColor: 'transparent',
    color: '#4CAF50',
    border: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  error: {
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    border: '1px solid #f44336',
    borderRadius: '8px',
    padding: '12px',
    color: '#f44336',
    fontSize: '14px'
  },
  footer: {
    color: '#666',
    fontSize: '12px',
    marginTop: '30px',
    lineHeight: '1.6'
  }
};

export default LoginScreen;
